import { withProps, Typography, tokens } from '@cast/design-system';

export const DrawerTitle = withProps(Typography, {
  variant: 'L12R',
  color: tokens.theme.fg.structural.secondary,
});
